import type { ButtonConfig } from '../../declare'
import { useMemo } from 'react'
import { EasyModal, EasyIcon, EditPage } from 'src/components'

type Props = {
  config: ButtonConfig
}

const ViewModalBtn = (props: Props) => {
  const formData = useMemo(() => {
    const { __RECORD__: record } = props.config
    return { formId: record.ID, formDisabled: true }
  }, [props.config.__RECORD__])

  const { __RENDER_SLOT__: renderSlot, LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: FORM_CODE, width: WIDTH }}
      slot={
        renderSlot?.(props.config) ?? (
          <span>
            <EasyIcon type={ICON} defaultIcon='EditOutlined' className='fz-16' />
            <span title={LABEL} className='pd-l4'>{LABEL}</span>
          </span>
        )
      }
    >
      <EditPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default ViewModalBtn